export function createClickId({ data, parent }) {
// clickID structure provided by Analytics request
  const clickIdString = `ip-_-${parent.name}-_-${parent.id}-_-${data.name}-_-${data.position}-_-${data.id}`;
  return clickIdString;
}